import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectDateRange } from '@pages/reporting-pages/deliveries-sku/store/selectors';
import { setDateRange } from '@pages/reporting-pages/deliveries-sku/store/slice';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';
import { DateRange } from '@project-types/DateRange';



const ParamsToolbar = () => {

	const dateRange = useSelector(selectDateRange);

	const dispatch = useDispatch();
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));


	return (
		<div className='reporting-params-toolbar'>
			
			<DateRangePicker
				label='Od - Do'
				isRequired={true}
				value={
					dateRange
					? { start: parseDate(dateRange.from), end: parseDate(dateRange.to) }
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateDateRange({
							from: rangeValue.start.toString(),
							to: rangeValue.end.toString(),
						});
					}
				}}
			/>

		</div>
	)
};

export default memo(ParamsToolbar);